import { useState, useEffect } from "react";
import Consultation from "../pages/Consultation"; // ← adjust path to match your project
import SEO from "../components/SEO";

const WHATSAPP_NUMBER = "919993999840";

const STORES = [
  {
    id: 1,
    name: "PR Hospital Designers",
    city: "Vijayawada",
    state: "Andhra Pradesh",
    tag: "Hospital Infrastructure",
    address: "54-15-1B, beside Yalamanchili Nageswara Rao Mansion, Veterinary Colony, Vijayawada, Andhra Pradesh 520008",
    phone: "+91 9993999840",
    email: "vijayawada@tevah.in",
  },
  {
    id: 2,
    name: "PR Infra & Hospitals Designers",
    city: "Hyderabad",
    state: "Telangana",
    tag: "Hospital Infrastructure",
    address: "8-1/7/7, beside GVR Villa's, Sundar Rao Nagar, Bahadurpally, Hyderabad, Telangana 500043",
    phone: "+91 9993999840",
    email: "hyderabad@tevah.in",
  },
];

const REVIEWS = [
  {
    name: "Dr. Suresh Reddy",
    role: "Administrator, Renova Neelima Hospital — Sanath Nagar, Hyderabad",
    initials: "SR",
    color: "#262E63",
    stars: 5,
    text: "PR Hospital Designers transformed our entire OT block across both A & B Blocks. The team understood infection control requirements perfectly and delivered a fully NABH-compliant setup within the agreed timeline.",
    tag: "OT Fit-out",
  },
  {
    name: "Anitha Krishnamurthy",
    role: "Admin, CC Sharoff Hospital — Kachiguda, Hyderabad",
    initials: "AK",
    color: "#3A4060",
    stars: 5,
    text: "We visited the experience centre and were blown away by the material options and scale models. The consultation felt personalised — not rushed at all. Highly recommend.",
    tag: "Experience Centre Visit",
  },
  {
    name: "Dr. Ramesh Babu",
    role: "Founder, Premier American Kidney Institute — Vijayawada",
    initials: "RB",
    color: "#3A4060",
    stars: 5,
    text: "Our diagnostic and dialysis suites were completed in 90 days, exactly as promised. The project manager was responsive throughout and the quality of finishes is top-notch.",
    tag: "Diagnostic Suite",
  },
  {
    name: "Priya Nagarajan",
    role: "CFO, Kiran Hospital — Karmanghat, Hyderabad",
    initials: "PN",
    color: "#343F86",
    stars: 4,
    text: "Good value for money. The ICU design is practical and the nursing station layout is exactly what we needed. Minor delays in procurement but the team communicated proactively.",
    tag: "ICU Suite",
  },
  {
    name: "Venkat Rao",
    role: "Trustee, Bhrungi Hospital — M.N. Reddy, Hyderabad",
    initials: "VR",
    color: "#262E63",
    stars: 5,
    text: "As a charitable institution working with a tight budget, PR Hospital Designers gave us a beautiful ward block without cutting corners on safety or hygiene. Very grateful for their commitment.",
    tag: "Ward Block",
  },
  {
    name: "Dr. Kavitha Sharma",
    role: "MD, Siddarth Neuro Hospital — Madinaguda, Hyderabad",
    initials: "KS",
    color: "#262E63",
    stars: 5,
    text: "The virtual tour option helped our board approve the design before we even visited. The final result matched the renders very closely. Professional team all around.",
    tag: "Neuro Suite Design",
  },
];

function StarRating({ count }) {
  return (
    <div style={{ color: "#f4b400", fontSize: 14, letterSpacing: 2 }}>
      {"★".repeat(count)}
      {"☆".repeat(5 - count)}
    </div>
  );
}

export default function ContactPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [showConsultation, setShowConsultation] = useState(false);

  const openConsultation = () => setShowConsultation(true);
  const closeConsultation = () => setShowConsultation(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showConsultation ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [showConsultation]);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Full name is required";
    if (!form.email.trim()) e.email = "Email address is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Enter a valid email";
    if (!form.phone.trim()) e.phone = "Phone number is required";
    return e;
  };

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const buildWhatsAppMessage = () => {
    const lines = [];
    lines.push(`Hi, I'd like to get in touch regarding a hospital infrastructure project.`);
    lines.push("");
    lines.push(`Name: ${form.name}`);
    lines.push(`Email: ${form.email}`);
    lines.push(`Phone: ${form.phone}`);
    if (form.location) {
      const locationLabel = form.location === "vijayawada"
        ? "Vijayawada — PR Hospital Designers"
        : form.location === "hyderabad"
        ? "Hyderabad — PR Infra & Hospitals Designers"
        : form.location;
      lines.push(`Preferred Location: ${locationLabel}`);
    }
    if (form.message.trim()) {
      lines.push("");
      lines.push(`Message:`);
      lines.push(form.message);
    }
    return lines.join("\n");
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }

    const message = buildWhatsAppMessage();
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");

    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setForm({ name: "", email: "", phone: "", location: "", message: "" });
    }, 5000);
  };

  return (
     <>
    <SEO/>
    <div className="ct-page">
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }

        .ct-page {
          background: #fff; color: #343F86; overflow-x: hidden;
          font-family: 'Inter', 'Montserrat', sans-serif;
          padding-top: 68px;
        }
        @media (max-width: 900px) { .ct-page { padding-top: 60px; } }
        @media (max-width: 480px) { .ct-page { padding-top: 56px; } }

        /* ── Hero (matches About page style — no image slider) ── */
        .ct-hero {
          background: #343F86;
          padding: 100px 40px;
          position: relative;
          overflow: hidden;
        }
        .ct-hero-grid {
          position: absolute; inset: 0;
          background-image: linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
          background-size: 48px 48px;
        }
        .ct-hero-glow {
          position: absolute; top: -120px; left: -80px;
          width: 500px; height: 500px;
          background: radial-gradient(circle, rgba(180,180,180,0.10) 0%, transparent 70%);
          pointer-events: none;
        }
        .ct-hero-inner { max-width: 1200px; margin: 0 auto; position: relative; z-index: 2; }
        .ct-hero-eyebrow {
          display: inline-block;
          font-size: 11px; font-weight: 600; letter-spacing: 3px;
          text-transform: uppercase; color: #7FD0DA;
          background: rgba(255,255,255,0.08); padding: 6px 14px;
          border-radius: 4px; margin-bottom: 24px;
        }
        .ct-hero h1 {
          font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: clamp(32px, 5vw, 56px);
          font-weight: 700; color: #fff; line-height: 1.15; margin-bottom: 24px;
          max-width: 680px;
        }
        .ct-hero p {
          font-size: 16px; color: #A7ACBD; line-height: 1.9;
          max-width: 560px;
        }
        @media (max-width: 768px) {
          .ct-hero { padding: 56px 20px; }
          .ct-hero-eyebrow { margin-bottom: 16px; font-size: 10.5px; padding: 5px 12px; }
          .ct-hero h1 { font-size: 30px; margin-bottom: 14px; }
          .ct-hero p { font-size: 14.5px; }
        }
        @media (max-width: 380px) {
          .ct-hero h1 { font-size: 26px; }
        }

        /* ── Main layout ── */
        .ct-main { max-width: 1100px; margin: 0 auto; padding: 56px 24px; display: grid; grid-template-columns: 1fr 1fr; gap: 56px; }
        @media (max-width: 768px) { .ct-main { grid-template-columns: 1fr; padding: 36px 16px; gap: 36px; } }
        @media (max-width: 480px) { .ct-main { padding: 28px 14px; gap: 28px; } }

        /* ── Section labels ── */
        .ct-eyebrow {
          font-size: 11px; font-weight: 600; letter-spacing: 3px;
          text-transform: uppercase; color: #2F8A98; margin-bottom: 12px;
        }
        .ct-heading {
          font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 26px; font-weight: 700; color: #343F86;
          margin-bottom: 10px; line-height: 1.2;
        }
        .ct-subtext { font-size: 15px; color: #5B6072; line-height: 1.75; margin-bottom: 28px; }
        @media (max-width: 768px) {
          .ct-heading { font-size: 21px; }
          .ct-subtext { font-size: 13.5px; margin-bottom: 20px; }
        }

        /* ── Address cards ── */
        .ct-addr-card {
          border: 1px solid #E1E3EE; border-radius: 14px;
          padding: 22px; margin-bottom: 16px;
          background: #F6F7FC;
        }
        @media (max-width: 480px) { .ct-addr-card { padding: 16px; border-radius: 12px; } }
        .ct-addr-tag {
          display: inline-block; font-size: 11px; font-weight: 700;
          background: #343F86; color: #fff; border-radius: 5px;
          padding: 3px 9px; margin-bottom: 14px; letter-spacing: 0.5px;
        }
        .ct-addr-row { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 14px; }
        .ct-addr-row:last-child { margin-bottom: 0; }
        .ct-addr-icon {
          width: 34px; height: 34px; min-width: 34px;
          background: #343F86; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          font-size: 15px;
        }
        @media (max-width: 480px) {
          .ct-addr-icon { width: 28px; height: 28px; min-width: 28px; font-size: 13px; border-radius: 7px; }
        }
        .ct-addr-label { font-size: 11px; font-weight: 700; color: #7FD0DA; letter-spacing: 0.5px; text-transform: uppercase; margin-bottom: 3px; }
        .ct-addr-val { font-size: 13px; color: #262E63; line-height: 1.6; word-break: break-word; }

        /* ── Hours ── */
        .ct-divider { height: 1px; background: #E1E3EE; margin: 24px 0; }
        .ct-hours-row {
          display: flex; justify-content: space-between; align-items: center;
          gap: 12px; padding: 9px 0; border-bottom: 1px solid #ECEEF6;
          font-size: 13px;
        }
        .ct-hours-row:last-child { border-bottom: none; }
        .ct-hours-day { color: #5B6072; }
        .ct-hours-time { font-weight: 600; color: #343F86; text-align: right; }

        /* ── Form card ── */
        .ct-form-card {
          background: #fff; border: 1px solid #E1E3EE;
          border-radius: 16px; padding: 32px 28px;
          box-shadow: 0 4px 32px rgba(0,0,0,0.05);
        }
        @media (max-width: 768px) { .ct-form-card { padding: 22px 18px; border-radius: 14px; } }

        /* ── Form fields ── */
        .ct-field { margin-bottom: 18px; }
        .ct-label {
          display: block; font-size: 12px; font-weight: 600;
          color: #5B6072; margin-bottom: 7px; letter-spacing: 0.3px;
        }
        .ct-required { color: #b91c1c; margin-left: 2px; }
        .ct-input, .ct-select, .ct-textarea {
          width: 100%; background: #F6F7FC;
          border: 1px solid #E1E3EE; border-radius: 10px;
          padding: 12px 16px; font-size: 14px; color: #343F86;
          font-family: 'Inter', 'Montserrat', sans-serif;
          outline: none; transition: border-color 0.2s, background 0.2s;
          appearance: none;
        }
        .ct-input:focus, .ct-select:focus, .ct-textarea:focus {
          border-color: #5B6072; background: #fff;
        }
        .ct-input.error, .ct-select.error, .ct-textarea.error {
          border-color: #b91c1c; background: #fdf6f6;
        }
        .ct-error-msg { font-size: 12px; color: #b91c1c; margin-top: 5px; }
        .ct-textarea { resize: vertical; min-height: 120px; line-height: 1.65; }
        .ct-select { cursor: pointer; }
        @media (max-width: 480px) {
          .ct-input, .ct-select, .ct-textarea { padding: 11px 14px; font-size: 13.5px; }
          .ct-textarea { min-height: 100px; }
        }

        /* ── Submit btn ── */
        .ct-submit {
          width: 100%; background: #343F86; color: #7FD0DA; border: none;
          border-radius: 10px; padding: 14px; font-size: 13px; font-weight: 700;
          font-family: 'Inter', 'Montserrat', sans-serif; cursor: pointer; letter-spacing: 0.5px;
          text-transform: uppercase; display: flex; align-items: center;
          justify-content: center; gap: 8px; transition: all 0.2s; margin-top: 4px;
        }
        .ct-submit:hover { background: #262E63; transform: translateY(-1px); }
        .ct-submit:active { transform: translateY(0); }

        /* ── Success ── */
        .ct-success {
          display: flex; align-items: center; gap: 10px;
          background: #ECEEF6; border: 1px solid #CDD1E0; border-radius: 10px;
          padding: 14px 16px; font-size: 13px; color: #343F86;
          margin-top: 14px; line-height: 1.5;
        }
        .ct-success-icon { font-size: 20px; flex-shrink: 0; }

        /* ── Reviews section ── */
        .ct-reviews-wrap { background: #ECEEF6; border-top: 1px solid #E1E3EE; padding: 64px 24px; }
        @media (max-width: 768px) { .ct-reviews-wrap { padding: 40px 18px; } }
        .ct-reviews-inner { max-width: 1100px; margin: 0 auto; }
        .ct-reviews-header {
          display: flex; align-items: flex-end; justify-content: space-between;
          margin-bottom: 36px; flex-wrap: wrap; gap: 16px;
        }
        @media (max-width: 480px) {
          .ct-reviews-header { align-items: flex-start; margin-bottom: 24px; }
        }
        .ct-rating-badge {
          display: flex; align-items: center; gap: 14px;
          background: #fff; border: 1px solid #E1E3EE; border-radius: 14px;
          padding: 14px 22px; box-shadow: 0 4px 16px rgba(0,0,0,0.05);
        }
        @media (max-width: 480px) {
          .ct-rating-badge { padding: 10px 16px; gap: 10px; width: 100%; }
        }
        .ct-rating-g { width: 32px; height: 32px; background: #fff; border: 1px solid #E1E3EE; border-radius: 6px; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: 900; color: #4285f4; flex-shrink: 0; }
        .ct-rating-num { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 28px; font-weight: 700; color: #343F86; line-height: 1; }
        .ct-rating-stars { color: #f4b400; font-size: 16px; letter-spacing: 1px; margin-top: 3px; }
        .ct-rating-sub { font-size: 11px; color: #8A8F9C; margin-top: 3px; }
        .ct-reviews-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; }
        @media (max-width: 900px) { .ct-reviews-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 560px) { .ct-reviews-grid { grid-template-columns: 1fr; gap: 14px; } }
        .ct-review-card {
          background: #fff; border: 1px solid #E1E3EE; border-radius: 14px;
          padding: 22px;
        }
        @media (max-width: 480px) { .ct-review-card { padding: 18px; } }
        .ct-review-top { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
        .ct-avatar {
          width: 42px; height: 42px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; font-weight: 700; color: #fff; flex-shrink: 0;
        }
        .ct-review-name { font-size: 14px; font-weight: 700; color: #343F86; margin-bottom: 2px; }
        .ct-review-role { font-size: 12px; color: #8A8F9C; line-height: 1.4; }
        .ct-review-stars { color: #f4b400; font-size: 13px; letter-spacing: 0.5px; margin-bottom: 10px; }
        .ct-review-text { font-size: 13px; color: #5B6072; line-height: 1.7; }
        .ct-review-tag {
          display: inline-block; margin-top: 12px; font-size: 11px; font-weight: 700;
          background: #ECEEF6; color: #5B6072; border-radius: 4px;
          padding: 3px 8px; letter-spacing: 0.3px;
        }

        /* ── Dream banner ── */
        .ct-dream {
          background: linear-gradient(135deg, #343F86 0%, #262E63 50%, #343F86 100%);
          padding: 72px 24px; text-align: center; position: relative; overflow: hidden;
        }
        @media (max-width: 768px) { .ct-dream { padding: 48px 20px; } }
        .ct-dream-dots { position: absolute; inset: 0; opacity: .04; background-image: radial-gradient(circle, #fff 1px, transparent 1px); background-size: 36px 36px; }
        .ct-dream-inner { position: relative; z-index: 1; }
        .ct-dream h2 {
          font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: clamp(26px, 4vw, 40px);
          font-weight: 700; color: #fff; margin-bottom: 28px; line-height: 1.2;
        }
        @media (max-width: 768px) { .ct-dream h2 { font-size: 24px; margin-bottom: 20px; } }
        .ct-dream-btn {
          background: #fff; color: #2F8A98; border: none; border-radius: 10px;
          padding: 16px 52px; font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 13px; font-weight: 700; cursor: pointer;
          letter-spacing: 0.5px; text-transform: uppercase; transition: all 0.25s;
        }
        .ct-dream-btn:hover { transform: translateY(-3px); box-shadow: 0 16px 44px rgba(255,255,255,0.18); }
        @media (max-width: 480px) { .ct-dream-btn { width: 100%; padding: 15px 32px; } }

        /* ── Consultation modal ── */
        .ct-modal-overlay {
          position: fixed; inset: 0; z-index: 2000;
          background: rgba(0,0,0,0.65);
          backdrop-filter: blur(5px);
          display: flex; align-items: center; justify-content: center;
          padding: 1rem;
        }
        .ct-modal-inner {
          position: relative; width: 100%; max-width: 680px;
          max-height: 90vh; overflow-y: auto; border-radius: 18px;
        }
        .ct-modal-close {
          position: absolute; top: 14px; right: 16px; z-index: 10;
          background: #262E63; border: none; color: #fff;
          width: 32px; height: 32px; border-radius: 50%;
          font-size: 20px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          line-height: 1;
        }
        .ct-modal-close:hover { background: #3A4060; }
      `}</style>

      {/* ── HERO (About-page style, no image) ── */}
      <div className="ct-hero">
        <div className="ct-hero-grid" />
        <div className="ct-hero-glow" />
        <div className="ct-hero-inner">
          <div className="ct-hero-eyebrow">PR Hospital Designers Hospital Infrastructure</div>
          <h1>Contact Us</h1>
          <p>Visit an experience centre or send us a message — our specialists are ready to help plan your facility.</p>
        </div>
      </div>

      {/* ── MAIN ── */}
      <div className="ct-main">

        {/* LEFT — addresses */}
        <div>
          <div className="ct-eyebrow">Our Locations</div>
          <div className="ct-heading">Experience Centres</div>
          <div className="ct-subtext">Drop in to explore hospital infrastructure models, OT fit-outs and ICU suites in person.</div>

          {STORES.map((s) => (
            <div className="ct-addr-card" key={s.id}>
              <div className="ct-addr-tag">{s.city}, {s.state}</div>
              <div className="ct-addr-row">
                <div className="ct-addr-icon">🏥</div>
                <div>
                  <div className="ct-addr-label">Name</div>
                  <div className="ct-addr-val" style={{ fontWeight: 600 }}>{s.name}</div>
                </div>
              </div>
              <div className="ct-addr-row">
                <div className="ct-addr-icon">📍</div>
                <div>
                  <div className="ct-addr-label">Address</div>
                  <div className="ct-addr-val">{s.address}</div>
                </div>
              </div>
              <div className="ct-addr-row">
                <div className="ct-addr-icon">📞</div>
                <div>
                  <div className="ct-addr-label">Phone</div>
                  <div className="ct-addr-val">{s.phone}</div>
                </div>
              </div>
              <div className="ct-addr-row">
                <div className="ct-addr-icon">✉️</div>
                <div>
                  <div className="ct-addr-label">Email</div>
                  <div className="ct-addr-val">{s.email}</div>
                </div>
              </div>
            </div>
          ))}

          <div className="ct-divider" />
          <div className="ct-eyebrow" style={{ marginBottom: 12 }}>Working Hours</div>
          <div className="ct-hours-row"><span className="ct-hours-day">Monday – Saturday</span><span className="ct-hours-time">10:00 AM – 7:00 PM</span></div>
          <div className="ct-hours-row"><span className="ct-hours-day">Sunday</span><span className="ct-hours-time" style={{ color: "#A7ACBD" }}>Closed</span></div>
          <div className="ct-hours-row"><span className="ct-hours-day">Consultation duration</span><span className="ct-hours-time">60 – 90 min</span></div>
        </div>

        {/* RIGHT — form */}
        <div>
          <div className="ct-eyebrow">Send a Message</div>
          <div className="ct-heading">Get in Touch</div>
          <div className="ct-subtext">Tell us about your project and we'll get back within one business day.</div>

          <div className="ct-form-card">
            {/* Full Name */}
            <div className="ct-field">
              <label className="ct-label" htmlFor="ct-name">
                Full Name <span className="ct-required">*</span>
              </label>
              <input
                id="ct-name"
                className={`ct-input${errors.name ? " error" : ""}`}
                type="text"
                placeholder="Enter Your Full Name"
                value={form.name}
                onChange={handleChange("name")}
              />
              {errors.name && <div className="ct-error-msg">{errors.name}</div>}
            </div>

            {/* Email */}
            <div className="ct-field">
              <label className="ct-label" htmlFor="ct-email">
                Email Address <span className="ct-required">*</span>
              </label>
              <input
                id="ct-email"
                className={`ct-input${errors.email ? " error" : ""}`}
                type="email"
                placeholder="Enter Your Email Address"
                value={form.email}
                onChange={handleChange("email")}
              />
              {errors.email && <div className="ct-error-msg">{errors.email}</div>}
            </div>

            {/* Phone */}
            <div className="ct-field">
              <label className="ct-label" htmlFor="ct-phone">
                Phone Number <span className="ct-required">*</span>
              </label>
              <input
                id="ct-phone"
                className={`ct-input${errors.phone ? " error" : ""}`}
                type="tel"
                placeholder="+91 9xxxxxxxx"
                value={form.phone}
                onChange={handleChange("phone")}
              />
              {errors.phone && <div className="ct-error-msg">{errors.phone}</div>}
            </div>

            {/* Location */}
            <div className="ct-field">
              <label className="ct-label" htmlFor="ct-location">Preferred Location</label>
              <select
                id="ct-location"
                className="ct-select"
                value={form.location}
                onChange={handleChange("location")}
              >
                <option value="">Select an experience centre</option>
                <option value="vijayawada">Vijayawada — PR Hospital Designers</option>
                <option value="hyderabad">Hyderabad — PR Infra &amp; Hospitals Designers</option>
              </select>
            </div>

            {/* Message */}
            <div className="ct-field">
              <label className="ct-label" htmlFor="ct-message">Your Message</label>
              <textarea
                id="ct-message"
                className="ct-textarea"
                placeholder="Tell us about your project — type of facility, estimated size, timeline..."
                value={form.message}
                onChange={handleChange("message")}
              />
            </div>

            <button className="ct-submit" onClick={handleSubmit}>
              💬 &nbsp;Send via WhatsApp
            </button>

            {submitted && (
              <div className="ct-success">
                <span className="ct-success-icon">✅</span>
                <span>We've opened WhatsApp with your details — just hit send, and our team will reach out shortly.</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ── REVIEWS ── */}
      <div className="ct-reviews-wrap">
        <div className="ct-reviews-inner">
          <div className="ct-reviews-header">
            <div>
              <div className="ct-eyebrow">Customer Feedback</div>
              <div className="ct-heading">What Our Clients Say</div>
            </div>
            <div className="ct-rating-badge">
              <div className="ct-rating-g">G</div>
              <div>
                <div className="ct-rating-num">4.8</div>
                <div className="ct-rating-stars">★★★★★</div>
                <div className="ct-rating-sub">Based on Google Reviews</div>
              </div>
            </div>
          </div>

          <div className="ct-reviews-grid">
            {REVIEWS.map((r, i) => (
              <div className="ct-review-card" key={i}>
                <div className="ct-review-top">
                  <div className="ct-avatar" style={{ background: r.color }}>{r.initials}</div>
                  <div>
                    <div className="ct-review-name">{r.name}</div>
                    <div className="ct-review-role">{r.role}</div>
                  </div>
                </div>
                <div className="ct-review-stars">{"★".repeat(r.stars)}{"☆".repeat(5 - r.stars)}</div>
                <div className="ct-review-text">{r.text}</div>
                <div className="ct-review-tag">{r.tag}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── DREAM BANNER ── */}
      <div className="ct-dream">
        <div className="ct-dream-dots" />
        <div className="ct-dream-inner">
          <h2>Your dream hospital is just a click away</h2>
          <button className="ct-dream-btn" onClick={openConsultation}>Get Started</button>
        </div>
      </div>

      {/* ── CONSULTATION MODAL ── */}
      {showConsultation && (
        <div
          className="ct-modal-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) closeConsultation(); }}
        >
          <div className="ct-modal-inner">
            <button className="ct-modal-close" onClick={closeConsultation} aria-label="Close consultation form">
              ×
            </button>
            <Consultation />
          </div>
        </div>
      )}
    </div>
    </>
  );
}